import { inject } from "ui-common/di";
import type { IWritableSubscriptionTierState, ISubscriptionTierService } from "./types";
import type { IRpcService } from "ui-common/services/rpc/types";
import type { IAuthProvider } from "ui-common/services/auth/types";
import type { GetMySubscriptionTierResult } from "api-contracts/rpc/get-my-subscription-tier";

export class SubscriptionTierService implements ISubscriptionTierService {
  @inject<IWritableSubscriptionTierState>("writableSubscriptionTierState")
  private state!: IWritableSubscriptionTierState;

  @inject<IRpcService>("rpcService")
  private rpcService!: IRpcService;

  @inject<IAuthProvider>("authProvider")
  private authProvider!: IAuthProvider;

  private pendingLoad: Promise<void> | undefined;

  loadTier(): void {
    if (!this.authProvider.isAuthenticated()) return;
    if (this.pendingLoad) return;

    this.state.loading.set(true);
    this.pendingLoad = this.doLoad();
  }

  reload(): void {
    this.pendingLoad = undefined;
    this.state.loading.set(true);
    this.pendingLoad = this.doLoad();
  }

  async updateTier(newMonthlyPriceCents: number): Promise<void> {
    await this.rpcService.call("update-subscription-tier", { newMonthlyPriceCents });
    this.reload();
  }

  private async doLoad(): Promise<void> {
    try {
      const result = await this.rpcService.call<GetMySubscriptionTierResult>("get-my-subscription-tier", {});
      this.state.tier.set(result);
    } catch (error) {
      console.error("[SubscriptionTierService] Error loading subscription tier:", error);
    } finally {
      this.state.loading.set(false);
      this.pendingLoad = undefined;
    }
  }
}
